export { isPasswordValid, validatePasswordConditionSeparatly, passwordRules } from './isPasswordValid';
export { containsEmoji } from './containsEmoji';
export { isDateOfBirthValid } from './isDateOfBirthValid';

export const isGamificationEnabled = () => process.env.REACT_APP_IS_GAMIFICATION_ENABLED === 'true';
export const isDexcomEnabled = () => process.env.REACT_APP_IS_DEXCOM_ENABLED === 'true';
export const isSignUpOrganizationEnabled = () => process.env.REACT_APP_SIGN_UP_ORGANIZATION === 'true';
